import { render, staticRenderFns } from "./HowCashbackWorks.vue?vue&type=template&id=b686aa24&scoped=true&"
import script from "./HowCashbackWorks.vue?vue&type=script&lang=js&"
export * from "./HowCashbackWorks.vue?vue&type=script&lang=js&"
import style0 from "./HowCashbackWorks.vue?vue&type=style&index=0&id=b686aa24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b686aa24",
  null
  
)

export default component.exports